import { BootstrapBrowserBuilder } from '@zg-rentals/rp-bootstrap-browser';

const appName = 'zrm-marketing-web';

const builder = new BootstrapBrowserBuilder(appName, Number(process.env.BUILD_NUMBER)).withHostedAppLoggerOptions(
  'rental-manager-api',
  process.env.NEXT_PUBLIC_LOG_LEVEL,
);

if (process.env.NEXT_PUBLIC_DD_APP_ID && process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN) {
  builder.withDatadogPlugin(process.env.NEXT_PUBLIC_DD_APP_ID!, process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN!);
}

export const bootstrap = builder.build();
